import { render, staticRenderFns } from "./post_recommend_set.vue?vue&type=template&id=29a2a242&scoped=true"
import script from "./post_recommend_set.vue?vue&type=script&lang=ts"
export * from "./post_recommend_set.vue?vue&type=script&lang=ts"
import style0 from "./post_recommend_set.vue?vue&type=style&index=0&id=29a2a242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2a242",
  null
  
)

export default component.exports